// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import store from "./store/index";

import ECharts from 'vue-echarts'
import { use } from 'echarts/core'
import { RadarChart } from 'echarts/charts';
import { GaugeChart  } from 'echarts/charts';
import { VisualMapComponent } from 'echarts/components'
import { ScatterChart } from 'echarts/charts';
import { EffectScatterChart } from 'echarts/charts';

import * as moment  from 'moment'
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import * as VeeValidate from 'vee-validate';
import VueSweetalert2 from 'vue-sweetalert2';
import VIcon from 'vue-tailwind-icons';
import VueCurrencyInput from 'vue-currency-input';
import VueHtmlToPaper from 'vue-html-to-paper';
// Make BootstrapVue available throughout your project
import Carousel3d from 'vue-carousel-3d';
import { ModelSelect } from 'vue-search-select'
import Multiselect from 'vue-multiselect'

Vue.use(BootstrapVue);
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin);
Vue.use(Carousel3d);
Vue.use(VIcon, { set: 'outline' });
Vue.component("vue-select-2", ModelSelect);
Vue.component('multiselect', Multiselect)

import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "vue-multiselect/dist/vue-multiselect.min.css";


import { MdIcon } from "vue-material/dist/components";

Vue.use(MdIcon);
Vue.use(moment);
Vue.use(VueCurrencyInput, {
  globalOptions: { currency: 'USD' }
})

import { library } from "@fortawesome/fontawesome-svg-core";
// internal icons
import { fas } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";


import eBar  from '@/components/Charts/Bar';
import ePie  from '@/components/Charts/Pie'
// Chart Custom 
Vue.component("chart-bar", eBar);
Vue.component("chart-pie", ePie);


library.add(fas);
Vue.component("vue-fontawesome", FontAwesomeIcon);
Vue.component('fa-icon', FontAwesomeIcon)
import "vue-material/dist/vue-material.min.css";


const options = {
  name :'_blank',
  specs: [
    'fullscreen=yes',
    'titlebar=yes',
    'scrollbars=yes'
  ],
  styles: [
    'https://sicantik.bogorkab.go.id/secure/assets/plugins/bootstrap/css/bootstrap.min.css',
    'https://sicantik.bogorkab.go.id/secure/assets/css/style.css',
     'https://sicantik.bogorkab.go.id/secure/assets/css/legacy.css'
  ],
  timeout: 1000, // default timeout before the print window appears
  autoClose: true, // if false, the window will not close after printing
  windowTitle: window.document.title, // override the window title
}
Vue.use(VueHtmlToPaper, options);


// Bootstrap
import  "./assets/plugins/bootstrap/css/bootstrap.min.css";
// Custom Style
import customStyle from "./assets/css/style.css";
import "./assets/css/legacy.css";
// Color
import colorStyle from "./assets/css/colors/colors.css";
import 'sweetalert2/dist/sweetalert2.min.css';
import 'vue-search-select/dist/VueSearchSelect.css'
// Simple line icon
//import  "./assets/css/icons/simple-line-icons/css/simple-line-icons.css";

// import ECharts modules manually to reduce bundle size
import {
  CanvasRenderer
} from 'echarts/renderers'
import {
  BarChart ,
  PieChart
} from 'echarts/charts'
import {
  GridComponent,
  TooltipComponent,
  TitleComponent,
   LegendComponent,

} from 'echarts/components'

use([
  CanvasRenderer,
  BarChart,
  PieChart,
  RadarChart,
  GaugeChart ,
  GridComponent,
  TooltipComponent ,
   LegendComponent, 
   TitleComponent,
   VisualMapComponent,
   ScatterChart ,
   EffectScatterChart
]);


Vue.use(customStyle);
Vue.use(colorStyle);
Vue.use(VeeValidate);
Vue.use(VueSweetalert2);
Vue.component('v-chart', ECharts)
// Layout Import
import LandingLayout from "./layout/Landing.vue";

// Layout Usage
Vue.component("landing-layout", LandingLayout);

Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js